<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:53:05
 * @LastEditTime: 2021-01-28 20:01:46
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\views\merchantCenter\orderManage\index.vue
-->
<template>
  <div>
    <el-card shadow="never">
      <el-form
        :model="searchParam"
        :inline="true"
        label-width="100px"
      >
        <el-form-item label="权益名称:">
          <el-input
            v-model="searchParam.equityName"
            clearable
            style="width: 200px;"
            maxlength="50"
            placeholder="请输入权益名称"
          />
        </el-form-item>

        <el-form-item label="会员姓名:">
          <el-input
            v-model="searchParam.createUserName"
            clearable
            style="width: 200px;"
            maxlength="50"
            placeholder="请输入会员姓名"
          />
        </el-form-item>

        <el-form-item label="订单编号:">
          <el-input
            v-model="searchParam.orderNumberNo"
            clearable
            style="width: 200px;"
            maxlength="50"
            placeholder="请输入订单编号"
          />
        </el-form-item>

        <el-form-item label="订单状态:">
          <el-select
            v-model="searchParam.statusCode"
            style="width: 200px;"
            clearable
            placeholder="请选择订单状态"
          >
            <el-option
              v-for="(value,key) in orderStatus"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="下单时间:">
          <el-date-picker
            v-model="searchParam.useTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
        </el-form-item>

        <el-form-item label="预约使用时间:">
          <el-date-picker
            v-model="searchParam.orderUsageTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item class="fr">
          <el-button
            type="primary"
            @click="getList('search')"
          >搜 索</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="flexBetween margin-t-20">
      <div>
        <el-radio-group
          v-model="searchParam.orderStatusCode"
          @change="sendTabCode"
        >
          <el-radio-button :label="0">待确认</el-radio-button>
          <el-radio-button :label="1">待核销</el-radio-button>
          <el-radio-button :label="2">已处理</el-radio-button>
          <el-radio-button :label="3">全部</el-radio-button>
        </el-radio-group>
      </div>

      <div>
        <el-button
          v-if="searchParam.orderStatusCode==0"
          type="primary"
          @click="showConfirmWindow"
        >批量确认</el-button>
        <el-button
          v-if="searchParam.orderStatusCode==0"
          type="primary"
          @click="showBackWindow"
        >批量退回</el-button>
        <el-button
          v-if="searchParam.orderStatusCode==1"
          type="primary"
          @click="cancel(1)"
        >批量核销</el-button>
      </div>
    </div>

    <el-card
      v-loading="loading"
      shadow="never"
    >
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="searchParam.orderStatusCode==0||searchParam.orderStatusCode==1"
          type="selection"
          width="55"
        />
        <el-table-column
          prop="xh"
          label="序号"
          width="50"
        />
        <el-table-column
          prop="orderNumberNo"
          label="订单编号"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="200"
            >
              <div slot="reference">
                {{ scope.row.orderNumberNo }}
              </div>
              <template>
                {{ scope.row.orderNumberNo }}
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="equityName"
          label="权益名称"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="200"
            >
              <div slot="reference">
                {{ scope.row.equityName }}
              </div>
              <template>
                {{ scope.row.equityName }}
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="权益分类">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              trigger="hover"
              :open-delay="200"
            >
              <div slot="reference">
                <div>{{ scope.row.sectionName }}</div>
                <div>{{ scope.row.categoryName }}</div>
              </div>
              <template>
                <div>{{ scope.row.sectionName }}</div>
                <div>{{ scope.row.categoryName }}</div>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="createUserName"
          label="会员姓名"
          width="100"
        />
        <el-table-column
          prop="memberLevelName"
          label="会员等级"
          width="100"
        />
        <el-table-column
          prop="createTime"
          label="下单时间"
          width="150"
        />
        <el-table-column
          prop="useTime"
          label="预约使用时间"
          width="180"
        />
        <el-table-column
          label="订单状态"
          width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.orderStatusCode|filterCode }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="$router.push({path:'/merchant/orderManage/info',query:{orderId:scope.row.orderId}})"
            >详情</el-button>
            <el-button
              v-if="searchParam.orderStatusCode==0"
              type="text"
              @click="$router.push({path:'/merchant/orderManage/confirm',query:{orderId:scope.row.orderId}})"
            >确认</el-button>
            <el-button
              v-if="searchParam.orderStatusCode==0"
              type="text"
              @click="$router.push({path:'/merchant/orderManage/back',query:{orderId:scope.row.orderId}})"
            >退回</el-button>
            <el-button
              v-if="searchParam.orderStatusCode==1"
              type="text"
              @click="cancel(2,scope.row.orderId)"
            >核销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="listTotal"
        :page.sync="searchParam.page.pageNum"
        :limit.sync="searchParam.page.pageSize"
        background
        layout="total, prev, pager, next, sizes"
        @pagination="getList('page')"
      />
    </el-card>
    <el-dialog
      :visible.sync="backVisible"
      title="退回订单"
      :show-close="false"
      :append-to-body="true"
      width="500px"
    >
      <el-form
        ref="backForm"
        :model="backForm"
        label-width="120px"
      >
        <el-form-item
          ref="remark"
          label="退回说明:"
          prop="remark"
          :rules="[
            {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
          ]"
        >
          <el-input
            v-model="backForm.remark"
            style="width:100%"
            placeholder="请输入退回说明"
            maxlength="200"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="back"
        >退回</el-button>
        <el-button @click="backVisible = false;$refs.backForm.resetFields()">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="confirmVisible"
      title="确认订单"
      :show-close="false"
      :append-to-body="true"
      width="600px"
    >
      <el-form
        ref="confirmForm"
        :model="confirmForm"
        label-width="120px"
      >
        <el-form-item
          ref="time"
          label="预约时间:"
          prop="time"
        >
          <el-date-picker
            v-model="confirmForm.time"
            style="width:100%"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item
          ref="remark"
          label="确认说明:"
          prop="remark"
          :rules="[
            {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
          ]"
        >
          <el-input
            v-model="confirmForm.remark"
            style="width:100%"
            placeholder="请输入确认说明"
            maxlength="200"
            type="textarea"
            :rows="3"
          />
        </el-form-item>

      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="confirm"
        >确认</el-button>
        <el-button @click="confirmVisible = false;$refs.confirmForm.resetFields()">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  merchantOrderRecordList,
  merchantOrderRecordWriteOff,
  merchantOrderRecordreturn,
  merchantOrderRecordConfirm
} from '@/api/merchantCenter'
import moment from 'moment'
export default {
  name: 'MerchantOrderManage',
  filters: {
    filterCode(val) {
      let name = ''
      switch (val) {
        case 0:
          name = '待确认'
          break
        case 1:
          name = '待使用'
          break
        case 2:
          name = '已使用'
          break
        case 3:
          name = '已过期'
          break
        case 4:
          name = '已退回'
          break
        default:
          name = '-'
          break
      }
      return name
    }
  },
  data() {
    return {
      loading: false,
      orderStatus: {
        0: '待确认',
        1: '待使用',
        2: '已使用',
        3: '已过期',
        4: '已退回'
      },
      tabStatus: {
        0: '待确认',
        1: '待核销',
        2: '已处理',
        3: '全部'
      },
      searchParam: {
        page: {
          pageNum: 1,
          pageSize: 10
        },
        equityName: '',
        createUserName: '',
        orderNumberNo: '',
        statusCode: null,
        orderStatusCode: 0,
        useTime: [],
        orderUsageTime: []
      },
      listTotal: 0,
      tableData: [],
      selectData: [],
      backVisible: false,
      backForm: { remark: '' },
      confirmVisible: false,
      confirmForm: { remark: '', time: [] }
    }
  },
  created() {
    if (this.$route.query.type == 1) {
      this.searchParam.orderStatusCode = 1
    }
  },
  // 页面缓存激活的时候刷新列表
  activated() {
    this.getList()
  },
  deactivated() {
    // 不是子路由的话做初始化
    if (this.$route.path.indexOf('/merchant/orderManage') === -1) {
      this.$store.dispatch('tagsView/delView', {
        name: 'MerchantOrderManage',
        path: '/merchant/orderManage'
      })
    }
  },
  methods: {
    sendTabCode(e) {
      this.searchParam.orderStatusCode = e
      this.getList()
    },
    async getList(type) {
      if (type !== 'page') {
        this.searchParam.page.pageNum = 1
        this.searchParam.page.pageSize = 10
      }
      try {
        this.loading = true
        if (type !== 'page') {
          this.searchParam.page.pageNum = 1
          this.searchParam.page.pageSize = 10
        }
        const obj = {
          equityName: this.searchParam.equityName,
          createUserName: this.searchParam.createUserName,
          orderNumberNo: this.searchParam.orderNumberNo,
          statusCode: this.searchParam.statusCode,
          orderStatusCode: this.searchParam.orderStatusCode,
          useStartTime: this.searchParam.useTime && this.searchParam.useTime[0]
            ? moment(this.searchParam.useTime[0]).format('YYYY-MM-DD')
            : null,
          useEndTime: this.searchParam.useTime && this.searchParam.useTime[1]
            ? moment(this.searchParam.useTime[1]).format('YYYY-MM-DD')
            : null,
          orderUsageStartTime: this.searchParam.orderUsageTime && this.searchParam.orderUsageTime[0]
            ? moment(this.searchParam.orderUsageTime[0]).format('YYYY-MM-DD')
            : null,
          orderUsageEndTime: this.searchParam.orderUsageTime && this.searchParam.orderUsageTime[1]
            ? moment(this.searchParam.orderUsageTime[1]).format('YYYY-MM-DD')
            : null,
          page: {
            pageNum: this.searchParam.page.pageNum,
            pageSize: this.searchParam.page.pageSize
          }
        }
        const res = await merchantOrderRecordList(obj)
        this.tableData = res.data.list
        this.listTotal = res.data.page.total
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    handleSelectionChange(e) {
      this.selectData = e
    },
    showBackWindow() {
      if (this.selectData.length === 0) {
        return this.$message.warning('请选择订单！')
      }
      this.backVisible = true
    },
    async back() {
      try {
        this.loading = true
        await merchantOrderRecordreturn({
          orderIdList: this.selectData.map(i => i.orderId),
          remark: this.confirmForm.remark
        })
        this.$message.success('退回成功！')
        this.backVisible = false
        this.getList()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    showConfirmWindow() {
      if (this.selectData.length === 0) {
        return this.$message.warning('请选择订单！')
      }
      this.confirmVisible = true
    },
    async confirm() {
      console.log(this.confirmForm.time)
      try {
        this.loading = true
        await merchantOrderRecordConfirm({
          orderIdList: this.selectData.map(i => i.orderId),
          remark: this.confirmForm.remark,
          reservationStartTime: this.confirmForm.time[0]
            ? moment(this.confirmForm.time[0]).format('YYYY-MM-DD HH:mm:ss')
            : null,
          reservationEndTime: this.confirmForm.time[1]
            ? moment(this.confirmForm.time[1]).format('YYYY-MM-DD HH:mm:ss')
            : null
        })
        this.$message.success('确认成功！')
        this.confirmVisible = false
        this.getList()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    /**
     * @param type 1批量 2单个
     */
    async cancel(type, id) {
      if (type == 1) {
        if (this.selectData.length === 0) {
          return this.$message.warning('请选择订单！')
        }
        this.$confirm(`是否确认核销选中订单?`, '提示', {
          type: 'warning'
        }).then(async() => {
          try {
            this.loading = true
            await merchantOrderRecordWriteOff({ orderIdList: this.selectData.map(i => i.orderId) })
            this.$message.success('核销成功！')
            this.getList()
            this.loading = false
          } catch (e) {
            this.loading = false
          }
        }).catch(() => {
          this.$message.info('已取消核销!')
        })
      } else if (type == 2) {
        this.$confirm(`是否确认核销当前订单?`, '提示', {
          type: 'warning'
        }).then(async() => {
          try {
            this.loading = true
            await merchantOrderRecordWriteOff({ orderIdList: [id] })
            this.$message.success('核销成功！')
            this.getList()
            this.loading = false
          } catch (e) {
            this.loading = false
          }
        }).catch(() => {
          this.$message.info('已取消核销!')
        })
      }
    }
  }
}
</script>
